import { useSiteImages } from "../hooks/useSiteImages";

export default function AllDonePage() {
  const { getImage } = useSiteImages();
  return (
    <div data-testid="alldone-page" className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-center mb-10 tracking-wide">
        <span className="text-[#D90429]">ALL DONE!</span>{" "}
        <span className="text-white">PLEASE CHECK YOUR EMAIL TO RETRIEVE YOUR EVENT TICKETS.</span>
      </h1>
      <img
        src={getImage("alldone_logo")}
        alt="Spectators Tickets Logo"
        className="max-w-md w-full"
      />
    </div>
  );
}
